/* eslint-disable @typescript-eslint/ban-ts-comment */
import I18n from 'i18n-js';
import { useEffect, useState } from 'react';
import { I18nt, API, lettersOnly } from 'utils';
import { Form, Button, message, Row, Col } from 'antd';
import validations from 'utils/validations/ContactForm';
import { InputText, Select, TextArea } from 'components/Inputs';
import { ContactFormParams } from 'utils/interfaces';
import { useLocation } from 'react-router-dom';

message.config({ top: 70 });

const options = ['queja', 'sugerencia', 'felicitacion'].map((opt) => ({
	value: I18n.t(opt),
	label: I18n.t(opt),
}));

export default function ContactForm() {
	const { state } = useLocation();
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	useEffect(() => {
		if (state) {
			form.setFieldsValue({ tipo: state });
		}
	}, [state]);

	const onValuesChange = (
		changedValues: ContactFormParams,
		allValues: ContactFormParams
	) => {
		if (changedValues.nombre) {
			allValues.nombre = lettersOnly(changedValues.nombre);
		}
		if (changedValues.apellido) {
			allValues.apellido = lettersOnly(changedValues.apellido);
		}
		form.setFieldsValue(allValues);
	};

	const onSubmit = async (data: ContactFormParams) => {
		setIsLoading(true);
		try {
			await API.sendMessage(data);
			message.success(I18nt('tu_mensaje_ha_sido_enviado'));
			form.resetFields();
		} catch (error) {
			message.error(I18nt('ha_ocurrido_un_error'));
		} finally {
			setIsLoading(false);
		}
	};

	const col = { xs: 24, lg: 12, xl: 10 };

	return (
		<Form
			form={form}
			layout='vertical'
			onFinish={onSubmit}
			validateTrigger='onBlur'
			onValuesChange={onValuesChange}
		>
			<Row gutter={16}>
				<Col {...col}>
					<Select
						name='tipo'
						options={options}
						placeholder='elige_una'
						rules={validations.tipo}
						label='selecciona_el_tipo'
						defaultValue={state as string}
					/>
				</Col>
			</Row>
			<Row justify='space-between' gutter={16}>
				<Col {...col}>
					<InputText
						label='nombre'
						name='nombre'
						rules={validations.nombre}
						placeholder='placeholder_nombre'
					/>
				</Col>
				<Col {...col}>
					<InputText
						name='apellido'
						label='apellido'
						rules={validations.apellido}
						placeholder='placeholder_apellido'
					/>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col {...col}>
					<InputText
						name='correo'
						label='email'
						inputMode='email'
						rules={validations.correo}
						placeholder='placeholder_email'
					/>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col xs={24}>
					<div className='mb-32'>
						<TextArea
							size={4}
							showCount
							name='mensaje'
							maxLength={2000}
							rules={validations.mensaje}
							label='escribe_tu_comentario'
							placeholder='placeholder_mensaje'
						/>
					</div>
				</Col>
			</Row>
			<Row justify='end'>
				<Col xs={24} lg={12}>
					<Form.Item className='mt-16'>
						<Button loading={isLoading} block type='primary' htmlType='submit'>
							{I18nt(isLoading ? 'enviando' : 'enviar')}
						</Button>
					</Form.Item>
				</Col>
			</Row>
		</Form>
	);
}
